<template>
    <div id="sidebar" class=" font-inter w-12 overflow-hidden bg-darkblue transition-all  duration-700 ease-in-out h-full " :class="opendrawer? 'w-48':''">
        <nav class="">
            
            <ul class="flex flex-col ">
                <li class="py-4 px-2">
                    <div class="flex">
                        <button class="focus:outline-none" @click="drawerToggle">
                            <svg  class="h-8" viewBox="0 0 50 50" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <line x1="9" y1="11.5" x2="40" y2="11.5" stroke="white" stroke-width="4" />
                                <line x1="9" y1="22.5" x2="40" y2="22.5" stroke="white" stroke-width="4" />
                                <line x1="9" y1="34.5" x2="40" y2="34.5" stroke="white" stroke-width="4" />
                            </svg>
                        </button>
                        <img src="/img/eYantra_logo_whitetext.png" class="h-6 ml-4 inline-block" v-if="opendrawer" />
                    </div>
                </li>

                 <!-- Admin Dashboard -->
                <li class="  hover:bg-blue-500 group" v-if="user.role == 1 ">
                    <Link href="/admin/dashboard" class="flex w-full items-center text-white py-4 px-2 ">
                        <span class="w-8">
                            <svg  xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" class=" h-8 w-8 ">
                                <path d="M3 4a1 1 0 011-1h12a1 1 0 011 1v2a1 1 0 01-1 1H4a1 1 0 01-1-1V4zM3 10a1 1 0 011-1h6a1 1 0 011 1v6a1 1 0 01-1 1H4a1 1 0 01-1-1v-6zM14 9a1 1 0 00-1 1v6a1 1 0 001 1h2a1 1 0 001-1v-6a1 1 0 00-1-1h-2z"/>
                            </svg> 
                        </span>
                        <span class=" pl-3 text-lg font-semibold" v-if="opendrawer">Dashboard </span>
                    </Link>
                </li>
                <li class="hover:bg-blue-500 group" v-if="user.role == 1 ">
                    <Link href="/admin/home" class="flex w-full items-center text-white py-4 px-2">
                        <span class="w-8">
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" class="h-8 w-8 ">
                                <path d="M9 2a1 1 0 000 2h2a1 1 0 100-2H9z" />
                                <path fill-rule="evenodd" d="M4 5a2 2 0 012-2 3 3 0 003 3h2a3 3 0 003-3 2 2 0 012 2v11a2 2 0 01-2 2H6a2 2 0 01-2-2V5zm3 4a1 1 0 000 2h.01a1 1 0 100-2H7zm3 0a1 1 0 000 2h3a1 1 0 100-2h-3zm-3 4a1 1 0 100 2h.01a1 1 0 100-2H7zm3 0a1 1 0 100 2h3a1 1 0 100-2h-3z" clip-rule="evenodd" />
                            </svg>
                        </span>
                        <span class=" pl-3 text-lg font-semibold " v-if="opendrawer">Actions </span>
                    </Link>
                </li>
                <!-- <li class=" hover:bg-blue-500 group " v-if="user.role == 1 ">
                    <Link href="/admin/project-status" class="flex w-full items-center text-yellow-500 py-4 px-2">
                        <span class="w-8">
                            <svg xmlns="http://www.w3.org/2000/svg" class=" h-8 w-8" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z" />
                            </svg>

                        </span>
                        
                        <span class=" pl-3 text-lg font-semibold" v-if="opendrawer">Proposal Stats </span>
                    </Link>
                </li> -->

                <!-- <li class=" hover:bg-blue-500 group " v-if="user.role == 1 ">
                    <Link href="/admin/project-decision" class="flex w-full items-center text-white py-4 px-2">
                        <span class="w-8">
                            <svg xmlns="http://www.w3.org/2000/svg" class=" h-8 w-8" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-6 9l2 2 4-4" />
                            </svg>

                        </span>
                        
                        <span class=" pl-3 text-lg font-semibold" v-if="opendrawer">Proposal Decision</span>
                    </Link>
                </li> -->
                
                <!-- <li class=" hover:bg-blue-500 group" v-if="user.role == 1">
                    <Link href="/admin/verify/mentor" class="flex w-full items-center py-4 px-2">
                        <span class="w-8">
                            <svg  viewBox="0 0 20 20" fill="currentColor" xmlns="http://www.w3.org/2000/svg" class="text-white h-8 w-8 ">
                                <path fill-rule="evenodd" clip-rule="evenodd" d="M10 2C9.44772 2 9 2.44772 9 3V4C9 4.55228 9.44772 5 10 5C10.5523 5 11 4.55228 11 4V3C11 2.44772 10.5523 2 10 2ZM4 4H7C7 5.65685 8.34315 7 10 7C11.6569 7 13 5.65685 13 4H16C17.1046 4 18 4.89543 18 6V15C18 16.1046 17.1046 17 16 17H4C2.89543 17 2 16.1046 2 15V6C2 4.89543 2.89543 4 4 4ZM6.5 11C7.32843 11 8 10.3284 8 9.5C8 8.67157 7.32843 8 6.5 8C5.67157 8 5 8.67157 5 9.5C5 10.3284 5.67157 11 6.5 11ZM8.95048 15C8.98327 14.8384 9.00049 14.6712 9.00049 14.5C9.00049 13.1193 7.8812 12 6.50049 12C5.11978 12 4.00049 13.1193 4.00049 14.5C4.00049 14.6712 4.0177 14.8384 4.0505 15H8.95048ZM12 9C11.4477 9 11 9.44772 11 10C11 10.5523 11.4477 11 12 11H15C15.5523 11 16 10.5523 16 10C16 9.44772 15.5523 9 15 9H12ZM11 13C11 12.4477 11.4477 12 12 12H14C14.5523 12 15 12.4477 15 13C15 13.5523 14.5523 14 14 14H12C11.4477 14 11 13.5523 11 13Z" />
                            </svg>
                        </span>
                        <span class=" pl-3 text-lg font-semibold text-white " v-if="opendrawer">ID Verfication </span>
                    </Link>
                </li> -->

                
            

                <!-- Student Dashboard -->
                <li class=" hover:bg-blue-500 group py-2" v-if="user.role == 4  || user.role == 5 ">
                    <Link href="/student/home" class="flex w-full items-center text-white py-2 px-2 ">
                        <span class="w-8">
                            <svg  xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" class=" h-6 w-8 ">
                                <path d="M3 4a1 1 0 011-1h12a1 1 0 011 1v2a1 1 0 01-1 1H4a1 1 0 01-1-1V4zM3 10a1 1 0 011-1h6a1 1 0 011 1v6a1 1 0 01-1 1H4a1 1 0 01-1-1v-6zM14 9a1 1 0 00-1 1v6a1 1 0 001 1h2a1 1 0 001-1v-6a1 1 0 00-1-1h-2z"/>
                            </svg> 
                        </span>
                        <span class=" pl-3  font-semibold " v-if="opendrawer">Dashboard </span>
                    </Link>
                </li>


                <li class="font-semibold text-white list-none block py-2 px-2  hover:bg-blue-500 group" v-if="(user.role == 4  || user.role == 5) && payment == true">

                    <Link href="/courses" class="flex w-full items-center text-white py-2  ">
                        <span class="w-8">
                            <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-8" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5S4.168 5.477 3 6.253v13C4.168 18.477 5.754 18 7.5 18s3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5c1.747 0 3.332.477 4.5 1.253v13C19.832 18.477 18.247 18 16.5 18c-1.746 0-3.332.477-4.5 1.253" />
                            </svg>
                        </span>
                        <span class=" pl-3  font-semibold " v-if="opendrawer">Courses </span>
                    </Link>
                </li>

                <!-- <li class="font-semibold text-white list-none block py-2 px-2  hover:bg-blue-500 group" v-if="(user.role == 4  || user.role == 5)">
                    <Link href="/student/alumni" class="flex w-full items-center text-white py-2  ">
                        <span class="w-8">
                            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-8 pl-1">
                                <path stroke-linecap="round"  stroke-linejoin="round" d="M4.26 10.147a60.436 60.436 0 00-.491 6.347A48.627 48.627 0 0112 20.904a48.627 48.627 0 018.232-4.41 60.46 60.46 0 00-.491-6.347m-15.482 0a50.57 50.57 0 00-2.658-.813A59.905 59.905 0 0112 3.493a59.902 59.902 0 0110.399 5.84c-.896.248-1.783.52-2.658.814m-15.482 0A50.697 50.697 0 0112 13.489a50.702 50.702 0 017.74-3.342M6.75 15a.75.75 0 100-1.5.75.75 0 000 1.5zm0 0v-3.675A55.378 55.378 0 0112 8.443m-7.007 11.55A5.981 5.981 0 006.75 15.75v-1.5" />
                            </svg>
                        </span>
                        <span class=" pl-3  font-semibold " v-if="opendrawer">Alumni </span>
                    </Link>
                </li> -->
                <li class="font-semibold text-white list-none block py-2 px-2  hover:bg-blue-500 group" v-if="(user.role == 4  || user.role == 5)">
                    <Link href="/student/proposal" class="flex w-full items-center text-white py-2  ">
                        <span class="w-8">
                            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-8 h-6 pl-1 ">
                             <path stroke-linecap="round" stroke-linejoin="round" d="M19.5 14.25v-2.625a3.375 3.375 0 00-3.375-3.375h-1.5A1.125 1.125 0 0113.5 7.125v-1.5a3.375 3.375 0 00-3.375-3.375H8.25m6.75 12l-3-3m0 0l-3 3m3-3v6m-1.5-15H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 00-9-9z" />
                            </svg>

                        </span>
                        <span class=" pl-3  font-semibold " v-if="opendrawer">Proposal  </span>
                    </Link>
                </li>

                

                

                <li class="font-semibold text-white list-none block py-2 px-2  hover:bg-blue-500 group" v-if="(user.role == 4  || user.role == 5)">
                    <Link href="/student/prototype-sprint" class="flex w-full items-center text-white py-2  ">
                        <span class="w-8">
                            <svg xmlns="http://www.w3.org/2000/svg" class="w-8 h-6 " viewBox="0 0 20 20" fill="currentColor" stroke-width="1.5">
                                <path fill-rule="evenodd" d="M7 2a1 1 0 00-.707 1.707L7 4.414v3.758a1 1 0 01-.293.707l-4 4C.817 14.769 2.156 18 4.828 18h10.343c2.673 0 4.012-3.231 2.122-5.121l-4-4A1 1 0 0113 8.172V4.414l.707-.707A1 1 0 0013 2H7zm2 6.172V4h2v4.172a3 3 0 00.879 2.12l1.027 1.028a4 4 0 00-2.171.102l-.47.156a4 4 0 01-2.53 0l-.563-.187a1.993 1.993 0 00-.114-.035l1.063-1.063A3 3 0 009 8.172z" clip-rule="evenodd" />
                            </svg>

                        </span>
                        <span class=" pl-3  font-semibold " v-if="opendrawer">Prototyping Sprint  </span>
                    </Link>
                </li>

                <li class=" hover:bg-blue-500 group " v-if="user.role == 4  || user.role == 5 ">
                    <Link href="/student/project-status" class="flex w-full items-center text-white py-4 px-2 text-yellow-300 ">
                        <span class="w-8">
                           
                            <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-8" viewBox="0 0 20 20" fill="currentColor">
                            <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
                            </svg>
                        </span>
                        <span class=" pl-3 font-semibold " v-if="opendrawer">Results
                         <!-- <span class="text-white bg-red-700 rounded px-2"> Certificate</span>  -->
                        </span>
                    
                    </Link>
                </li>
<!--  
                <li class="font-semibold text-white list-none block py-2 px-2" v-if="(user.role == 4  || user.role == 5 ) && (team_status.status_id  >= 5)">
                    <div class="flex items-center justify-between mb-2 cursor-pointer" @click="toggleShow(3)">

                        <span class="w-8">
                            <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-8" viewBox="0 0 20 20" fill="currentColor">
                             <path d="M11 3a1 1 0 10-2 0v1a1 1 0 102 0V3zM15.657 5.757a1 1 0 00-1.414-1.414l-.707.707a1 1 0 001.414 1.414l.707-.707zM18 10a1 1 0 01-1 1h-1a1 1 0 110-2h1a1 1 0 011 1zM5.05 6.464A1 1 0 106.464 5.05l-.707-.707a1 1 0 00-1.414 1.414l.707.707zM5 10a1 1 0 01-1 1H3a1 1 0 110-2h1a1 1 0 011 1zM8 16v-1h4v1a2 2 0 11-4 0zM12 14c.015-.34.208-.646.477-.859a4 4 0 10-4.954 0c.27.213.462.519.476.859h4.002z" />
                            </svg>
                        </span>
                        
                        <span v-if="opendrawer " class="ml-3" >Innovation Sprint</span>

                        <svg v-if="opendrawer" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="3" stroke="currentColor" :class="{'rotate-90' : showMenu3}" class="w-4 h-4 dropdown-menu text-white">
                            <path stroke-linecap="round" stroke-linejoin="round" d="M8.25 4.5l7.5 7.5-7.5 7.5" />
                        </svg>
                    </div>
                    <ul class="overflow-hidden dropdown-menu" v-if="showMenu3">
                        
                        <li class=" hover:bg-blue-500 group" >
                            <Link href="/innovation-courses" class="flex w-full items-center text-white py-2 px-2 ">
                                
                                <span class=" pl-3 font-semibold " v-if="opendrawer">Courses </span>
                            </Link>
                        </li> 
                        <li class=" hover:bg-blue-500 group" >
                            <Link href="/student/innovation-sprint" class="flex w-full items-center text-white py-2 px-2 text-white">
                                <span class=" pl-3 font-semibold " v-if="opendrawer"> Submission </span>
                            </Link>
                        </li> 
                    </ul>
                </li>  -->
                        
                 <li class=" hover:bg-blue-500 group" v-if="(user.role == 4  || user.role == 5 ) && (team_status.status_id  >= 4)">
                    <Link href="/student/implementation-sprint" class="flex w-full items-center text-white py-4 px-2 text-white">
                        <span class="w-8">
                            <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-8" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                <path d="M12 14l9-5-9-5-9 5 9 5z" />
                                <path d="M12 14l6.16-3.422a12.083 12.083 0 01.665 6.479A11.952 11.952 0 0012 20.055a11.952 11.952 0 00-6.824-2.998 12.078 12.078 0 01.665-6.479L12 14z" />
                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 14l9-5-9-5-9 5 9 5zm0 0l6.16-3.422a12.083 12.083 0 01.665 6.479A11.952 11.952 0 0012 20.055a11.952 11.952 0 00-6.824-2.998 12.078 12.078 0 01.665-6.479L12 14zm-4 6v-7.5l4-2.222" />
                            </svg>
                        </span>
                        <span class=" pl-3  font-semibold " v-if="opendrawer">Implementation Sprint</span>
                    </Link>
                </li>
                

                
                <!-- Mentor Dashboard -->
                <li class="hover:bg-blue-500 group" v-if="user.role == 3 || user.role == 6">
                    <Link href="/mentor/home" class="flex w-full items-center text-white py-2 px-2 ">
                        <span class="w-8">
                            <svg  xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" class=" h-8 w-8 ">
                                <path d="M3 4a1 1 0 011-1h12a1 1 0 011 1v2a1 1 0 01-1 1H4a1 1 0 01-1-1V4zM3 10a1 1 0 011-1h6a1 1 0 011 1v6a1 1 0 01-1 1H4a1 1 0 01-1-1v-6zM14 9a1 1 0 00-1 1v6a1 1 0 001 1h2a1 1 0 001-1v-6a1 1 0 00-1-1h-2z"/>
                            </svg> 
                        </span>
                        <span class=" pl-3 text-lg font-semibold " v-if="opendrawer">Dashboard </span>
                    </Link>
                </li>
                <li class="font-semibold text-white list-none block py-2 hover:bg-blue-500 group" v-if="(user.role == 3 || user.role == 6 ) && payment == true">
                    <Link href="/courses" class="flex w-full items-center text-white py-2 px-2 ">
                        <span class="w-8">
                            <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-8" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5S4.168 5.477 3 6.253v13C4.168 18.477 5.754 18 7.5 18s3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5c1.747 0 3.332.477 4.5 1.253v13C19.832 18.477 18.247 18 16.5 18c-1.746 0-3.332.477-4.5 1.253" />
                            </svg>
                        </span>
                        <span class=" pl-3 text-lg font-semibold " v-if="opendrawer">Courses </span>
                    </Link>
                </li>

                <li class=" hover:bg-blue-500 group" v-if="user.role == 3">
                    <Link href="/mentor/proposal" class="flex w-full items-center text-white py-2 px-2 ">
                        <span class="w-8">
                            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-8 h-6 pl-1 ">
                             <path stroke-linecap="round" stroke-linejoin="round" d="M19.5 14.25v-2.625a3.375 3.375 0 00-3.375-3.375h-1.5A1.125 1.125 0 0113.5 7.125v-1.5a3.375 3.375 0 00-3.375-3.375H8.25m6.75 12l-3-3m0 0l-3 3m3-3v6m-1.5-15H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 00-9-9z" />
                            </svg>

                        </span>
                        <span class=" pl-3 text-lg font-semibold " v-if="opendrawer">Proposal </span>
                    </Link>
                </li>
                <!-- && (project_data && project_data.project_status >= 3) -->
                <li class="font-semibold text-white list-none block py-2 hover:bg-blue-500 group" v-if="user.role == 3 ">
                    <Link href="/mentor/prototype-sprint" class="flex w-full items-center text-white py-2 px-2">
                    <span class="w-8">
                        <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-8" viewBox="0 0 20 20" fill="currentColor">
                        <path fill-rule="evenodd" d="M7 2a1 1 0 00-.707 1.707L7 4.414v3.758a1 1 0 01-.293.707l-4 4C.817 14.769 2.156 18 4.828 18h10.343c2.673 0 4.012-3.231 2.122-5.121l-4-4A1 1 0 0113 8.172V4.414l.707-.707A1 1 0 0013 2H7zm2 6.172V4h2v4.172a3 3 0 00.879 2.12l1.027 1.028a4 4 0 00-2.171.102l-.47.156a4 4 0 01-2.53 0l-.563-.187a1.993 1.993 0 00-.114-.035l1.063-1.063A3 3 0 009 8.172z" clip-rule="evenodd" />
                        </svg>
                    </span>
                    <span class=" pl-3 font-semibold " v-if="opendrawer">Prototyping Sprint</span>
                    </Link> 
                </li>
                <li class=" hover:bg-blue-500 group" v-if="user.role == 3 ">
                    <Link href="/mentor/project-status" class="flex w-full items-center text-white py-4 px-2 text-white">
                        <span class="w-8">
                           
                            <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-8" viewBox="0 0 20 20" fill="currentColor">
                            <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
                            </svg>
                        </span>
                        <span class=" pl-3  font-semibold " v-if="opendrawer">Results
                          
                            </span>
                    </Link>
                </li>

               

                <!-- <li class="font-semibold text-white list-none block py-2 px-2" v-if="user.role == 3 ">
                    <div class="flex items-center justify-between mb-2 cursor-pointer" @click="toggleShow(3)">

                        <span class="w-8">
                            <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-8" viewBox="0 0 20 20" fill="currentColor">
                             <path d="M11 3a1 1 0 10-2 0v1a1 1 0 102 0V3zM15.657 5.757a1 1 0 00-1.414-1.414l-.707.707a1 1 0 001.414 1.414l.707-.707zM18 10a1 1 0 01-1 1h-1a1 1 0 110-2h1a1 1 0 011 1zM5.05 6.464A1 1 0 106.464 5.05l-.707-.707a1 1 0 00-1.414 1.414l.707.707zM5 10a1 1 0 01-1 1H3a1 1 0 110-2h1a1 1 0 011 1zM8 16v-1h4v1a2 2 0 11-4 0zM12 14c.015-.34.208-.646.477-.859a4 4 0 10-4.954 0c.27.213.462.519.476.859h4.002z" />
                            </svg>
                        </span>
                        
                        <span v-if="opendrawer " class="ml-3" >Innovation Sprint</span>

                        <svg v-if="opendrawer" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="3" stroke="currentColor" :class="{'rotate-90' : showMenu3}" class="w-4 h-4 dropdown-menu text-white">
                            <path stroke-linecap="round" stroke-linejoin="round" d="M8.25 4.5l7.5 7.5-7.5 7.5" />
                        </svg>
                    </div>
                    <ul class="overflow-hidden dropdown-menu" v-if="showMenu3">
                        
                        <li class=" hover:bg-blue-500 group" >
                            <Link href="/innovation-courses" class="flex w-full items-center text-white py-2 px-2 ">
                                
                                <span class=" pl-3 font-semibold " v-if="opendrawer">Courses </span>
                            </Link>
                        </li> 
                        <li class=" hover:bg-blue-500 group" >
                            <Link href="/mentor/innovation-sprint" class="flex w-full items-center text-white py-2 px-2 text-white">
                                <span class=" pl-3 font-semibold " v-if="opendrawer"> Submission </span>
                            </Link>
                        </li> 
                    </ul>
                </li>  -->
                
                 <li class=" hover:bg-blue-500 group" v-if="(user.role == 3) ">
                    <Link href="/mentor/implementation-sprint" class="flex w-full items-center text-white py-4 px-2 text-white">
                        <span class="w-8">
                            <svg xmlns="http://www.w3.org/2000/svg" class="h-8 w-6" viewBox="0 0 20 20" fill="currentColor">
                             <path d="M11 3a1 1 0 10-2 0v1a1 1 0 102 0V3zM15.657 5.757a1 1 0 00-1.414-1.414l-.707.707a1 1 0 001.414 1.414l.707-.707zM18 10a1 1 0 01-1 1h-1a1 1 0 110-2h1a1 1 0 011 1zM5.05 6.464A1 1 0 106.464 5.05l-.707-.707a1 1 0 00-1.414 1.414l.707.707zM5 10a1 1 0 01-1 1H3a1 1 0 110-2h1a1 1 0 011 1zM8 16v-1h4v1a2 2 0 11-4 0zM12 14c.015-.34.208-.646.477-.859a4 4 0 10-4.954 0c.27.213.462.519.476.859h4.002z" />
                            </svg>
                        </span>
                        <span class=" pl-3  font-semibold " v-if="opendrawer">Implementation Sprint</span>
                    </Link>
                </li>
              
                

                <!-- common -->
                 <!-- <li class="  hover:bg-blue-500 group" v-if="(user.role == 4 || user.role == 3 || user.role == 5) && (project_data && project_data.project_status >= 9)">
                    <Link href="/bank-details" class="flex w-full items-center text-secondary py-4 px-2 ">
                        <span class="w-8">
                            <svg xmlns="http://www.w3.org/2000/svg" class="inline-block h-8 w-8" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                                <path stroke-linecap="round" stroke-linejoin="round" d="M17 9V7a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2m2 4h10a2 2 0 002-2v-6a2 2 0 00-2-2H9a2 2 0 00-2 2v6a2 2 0 002 2zm7-5a2 2 0 11-4 0 2 2 0 014 0z" />
                            </svg>
                        </span>
                        <span class=" pl-3 text-lg font-semibold " v-if="opendrawer">Bank Details </span>
                    </Link>
                </li>  -->






                <!-- Reviewer Dashboard -->

                <li class=" hover:bg-blue-500 group" v-if="user.role == 2">
                    <Link href="/reviewer/implementation-review" class="flex w-full items-center text-white py-4 px-2 ">
                        <span class="w-8">

                            <svg xmlns="http://www.w3.org/2000/svg" class="h-8 w-8" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 10l4.553-2.276A1 1 0 0121 8.618v6.764a1 1 0 01-1.447.894L15 14M5 18h8a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v8a2 2 0 002 2z" />
                            </svg>
                        </span>
                        <span class=" pl-3 text-lg font-semibold " v-if="opendrawer">Implemenation Review</span>
                    </Link>
                </li> 

                <!-- <li class=" hover:bg-blue-500 group" v-if="user.role == 2">
                    <Link href="/reviewer/innovation-eval" class="flex w-full items-center text-white py-4 px-2 ">
                        <span class="w-8">

                            <svg xmlns="http://www.w3.org/2000/svg" class="h-8 w-8" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 10l4.553-2.276A1 1 0 0121 8.618v6.764a1 1 0 01-1.447.894L15 14M5 18h8a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v8a2 2 0 002 2z" />
                            </svg>
                        </span>
                        <span class=" pl-3 text-lg font-semibold " v-if="opendrawer">Innovation Eval</span>
                    </Link>
                </li> -->

                <!-- <li class=" hover:bg-blue-500 group" v-if="user.role == 2">
                    <Link href="/reviewer/mid-review-eval" class="flex w-full items-center text-white py-4 px-2 ">
                        <span class="w-8">
                           <svg xmlns="http://www.w3.org/2000/svg" class="h-8 w-8" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M7 12l3-3 3 3 4-4M8 21l4-4 4 4M3 4h18M4 4h16v12a1 1 0 01-1 1H5a1 1 0 01-1-1V4z" />
                            </svg>
                        </span>
                        <span class=" pl-3 text-lg font-semibold " v-if="opendrawer">Mid-review </span>
                    </Link>
                </li> -->
                <li class=" hover:bg-blue-500 group" v-if="user.role == 2">
                    <Link href="/reviewer/home" class="flex w-full items-center text-white py-4 px-2 ">
                        <span class="w-8">
                            <svg  xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" class=" h-8 w-8 ">
                                <path d="M3 4a1 1 0 011-1h12a1 1 0 011 1v2a1 1 0 01-1 1H4a1 1 0 01-1-1V4zM3 10a1 1 0 011-1h6a1 1 0 011 1v6a1 1 0 01-1 1H4a1 1 0 01-1-1v-6zM14 9a1 1 0 00-1 1v6a1 1 0 001 1h2a1 1 0 001-1v-6a1 1 0 00-1-1h-2z"/>
                            </svg> 
                        </span>
                        <span class=" pl-3 text-lg font-semibold " v-if="opendrawer">Dashboard </span>
                    </Link>
                </li>
                <!-- <li class=" hover:bg-blue-500 group" v-if="user.role == 2">
                    <Link href="/reviewer/submission" class="flex w-full items-center text-white py-4 px-2 ">
                        <span class="w-8">
                            <svg xmlns="http://www.w3.org/2000/svg" class="h-8 w-8" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 10v6m0 0l-3-3m3 3l3-3m2 8H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                            </svg>
                        </span>
                        <span class=" pl-3 text-lg font-semibold " v-if="opendrawer">Mooc Submission </span>
                    </Link>
                </li> -->
                
                <!-- <li class="  hover:bg-blue-500 group" v-if="user.role == 2">
                    <Link href="/reviewer/verify/student" class="flex w-full items-center text-white py-4 px-2 ">
                        <span class="w-8">
                            <svg  viewBox="0 0 20 20" fill="currentColor" xmlns="http://www.w3.org/2000/svg" class=" h-8 w-8 ">
                                <path fill-rule="evenodd" clip-rule="evenodd" d="M10 2C9.44772 2 9 2.44772 9 3V4C9 4.55228 9.44772 5 10 5C10.5523 5 11 4.55228 11 4V3C11 2.44772 10.5523 2 10 2ZM4 4H7C7 5.65685 8.34315 7 10 7C11.6569 7 13 5.65685 13 4H16C17.1046 4 18 4.89543 18 6V15C18 16.1046 17.1046 17 16 17H4C2.89543 17 2 16.1046 2 15V6C2 4.89543 2.89543 4 4 4ZM6.5 11C7.32843 11 8 10.3284 8 9.5C8 8.67157 7.32843 8 6.5 8C5.67157 8 5 8.67157 5 9.5C5 10.3284 5.67157 11 6.5 11ZM8.95048 15C8.98327 14.8384 9.00049 14.6712 9.00049 14.5C9.00049 13.1193 7.8812 12 6.50049 12C5.11978 12 4.00049 13.1193 4.00049 14.5C4.00049 14.6712 4.0177 14.8384 4.0505 15H8.95048ZM12 9C11.4477 9 11 9.44772 11 10C11 10.5523 11.4477 11 12 11H15C15.5523 11 16 10.5523 16 10C16 9.44772 15.5523 9 15 9H12ZM11 13C11 12.4477 11.4477 12 12 12H14C14.5523 12 15 12.4477 15 13C15 13.5523 14.5523 14 14 14H12C11.4477 14 11 13.5523 11 13Z" />
                            </svg>
                        </span>
                        <span class=" pl-3 text-lg font-semibold " v-if="opendrawer">Id Verrification </span>
                    </Link>
                </li> -->
              
            </ul>
           
       
        </nav>
    </div>
</template>
<script>
import { Link } from '@inertiajs/inertia-vue3'
import { computed } from 'vue'
import { usePage } from '@inertiajs/inertia-vue3'

export default {
    setup() {
    const user = computed(() => usePage().props.value.auth.user)
    const project_data = computed(() => usePage().props.value.project_data)
    const payment = computed(() => usePage().props.value.payment)
    const team_status = computed(() => usePage().props.value.team_status)
    console.log(team_status);
    return { user,project_data,payment,team_status }
  },
    data(){
        return{
            opendrawer:true,
           
            showMenu2: false,
            showMenu3: false,
        }
    },
   
    components:{
        Link
    }
    ,
    methods:{
        drawerToggle(){
            this.opendrawer=!this.opendrawer
            console.log(this.project_data);
            this.$emit('toggle-sidebar-drawer',this.opendrawer)
        },

        toggleShow(id) {
            switch(id){
              
                case 2 : this.showMenu2 = !this.showMenu2; 
                         this.showMenu3= false;
                         break;
                case 3 : this.showMenu3 = !this.showMenu3; 
                         this.showMenu2= false;
            }
        }
    }
}
</script>

<style scoped>
#sidebar::-webkit-scrollbar{
  width: 0.75rem;
}
#sidebar::-webkit-scrollbar-track{
  background:#1e1e24
}
#sidebar::-webkit-scrollbar-thumb{
  background:#6649b8;
}
svg.rotate-90 {
  transform: rotate(90deg);
}
</style>